module.exports = __webpack_public_path__ + "img/pic_empty_403txt@2x.5e9dd0fa.png";